import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Material } from './material.model';

export interface MaterialState extends EntityState<Material> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'material', resettable: true })
export class MaterialStore extends EntityStore<MaterialState> {
  constructor() {
    super();
  }
}
